import { hitsApi } from '../../../api';
import type { GameStateGetter } from '../types';

export const createDeleteHit = (get: GameStateGetter) => {
  return async (boardId: string, hitId: string): Promise<void> => {
    await hitsApi.delete(boardId, hitId);
    await get().fetchHits(boardId);
  };
};
